import { Injectable } from '@angular/core';
import { TableData } from './definitions';
import { SortOrder } from '../card-list/definitions';
@Injectable({
	providedIn: 'root'
})
export class KngDataTableService 
{
	sortGridData(array: TableData[], sortOrder: string, sortField: string): TableData[] 
	{
		array.sort((a: TableData, b: TableData) =>
		{
			const sortedA = a[sortField as keyof TableData];
			const sortedB = b[sortField as keyof TableData];
			if(sortedA && sortedB && typeof(sortedA) === 'string' && typeof(sortedB) === 'string')
			{
				if(sortOrder === SortOrder.asc)
				{
					return this.sortGridDataAsc(sortedA, sortedB);
				}
				else
				{
					return this.sortGridDataDesc(sortedA, sortedB);
				}
			}
			else
				return 0;
		});
		return array;
	}
	sortGridDataAsc(sortedA: string, sortedB: string)
	{
		if (sortedA.toLowerCase() < sortedB.toLowerCase()) 
			return -1;
		else if (sortedA.toLowerCase() > sortedB.toLowerCase())
			return 1;
		else
			return 0;
	}
	sortGridDataDesc(sortedA: string, sortedB: string)
	{
		if (sortedA.toLowerCase() > sortedB.toLowerCase()) 
			return -1;
		else if (sortedA.toLowerCase() < sortedB.toLowerCase())
			return 1;
		else
			return 0;
	}
}
